import { NoticeType } from '@/@types/global';
import axios, { AxiosResponse } from 'axios';

/**
 * @description 推播訊息列表回應物件
 * @property {object[]} data - 推播訊息列表
 * @property {number} data.id - 推播訊息id
 * @property {string} data.type - 推播訊息類型
 * @property {string} data.date - 推播訊息日期
 * @property {string} data.title - 推播訊息標題
 * @property {string} data.content - 推播訊息內容
 */
/**
 * @description 推播訊息列表回應物件
 * @property {object[]} data - 推播訊息列表
 * @property {number} data.id - 推播訊息id
 * @property {string} data.type - 推播訊息類型
 * @property {string} data.date - 推播訊息日期
 * @property {string} data.title - 推播訊息標題
 * @property {string} data.content - 推播訊息內容
 */
export interface TResponse {
    data: {
        id: number;
        type: string;
        date: string;
        title: string;
        content: string;
        sender: string;
        isRead: boolean;
        itemName: NoticeType | null;
        orderId: number | null;
        notificationSource: string | null; // 推播來源(推播介面發送(管理員),推播介面發送(體系),行程通知,用藥提醒通知,待辦事項提醒,追蹤人通知,視訊關懷預約通知,視訊關懷取消通知,視訊關懷即將開始通知,衛教推播通知)
    }[];
}

export default async function apiGetPushNoticeListLittleBell() {
    const response: AxiosResponse<TResponse, null> = await axios.request({
        url: `/api/push-notice/list-little-bell`,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return response;
}
